export const energy_providers = {
  texas_ep: [
    '174 POWER GLOBAL RETAIL ENERGY TEXAS',
    '4CHANGE ENERGY',
    'ACACIA ENERGY',
    'ACCEL ENERGY',
    'ACCENT ENERGY',
    'AES NEWENERGY',
    'AGERA ENERGY',
    'ALLIANCE POWER COMPANY',
    'ALLTEX POWER & LIGHT',
    'AMBIT ENERGY',
    'AMERICAN LIGHT & POWER',
    'AMERIPOWER',
    'AMIGO ENERGY',
    'AMPRA ENERGY',
    'APG&E',
    'ASSURANCE ENERGY',
    'ATG CLEAN ENERGY',
    'AXON POWER',
    'BEYOND ENERGY',
    'BLUE STAR ENERGY',
    'BOUNCE ENERGY',
    'BP ENERGY',
    'BREEZE ENERGY',
    'BRIGHTSTAR POWER ',
    'BRILLIANT ENERGY',
    'BULB',
    'CALPINE ENERGY',
    'CHAMPION ENERGY SERVICES',
    'CHARIOT ENERGY',
    'CIRCULAR ENERGY',
    'CIRRO ENERGY',
    'CLEARSKY ENERGY',
    'CLEARVIEW ENERGY',
    'COMPASSION ENERGY',
    'CONSERVICE ENERGY',
    'CONSTELLATION',
    'CONSTELLATION NEWENERGY',
    'CORAL POWER',
    'COST PLUS ENERGY',
    'CPL RETAIL ENERGY',
    'DECLARATION ENERGY',
    'DIRECT ENERGY',
    'DISCOUNT POWER',
    'DYNOWATT',
    'EAGLE ENERGY',
    'EDF ENERGY SERVICES',
    'ELIGO ENERGY',
    'ENCOA',
    'ENERGY HARBOR',
    'ENERGY MONGER',
    'ENERGY REWARDS',
    'ENERGY TO GO',
    'ENGIE RETAIL',
    'ENTRUST ENERGY',
    'EPIQ ENERGY',
    'EVERYTHING ENERGY',
    'EVOLVE ENERGY',
    'EXPERT ENERGY',
    'EXPRESS ENERGY',
    'FIRST CHOICE POWER',
    'FREEPOINT ENERGY SOLUTIONS',
    'FRONTIER UTILITIES',
    'FULCRUM RETAIL ENERGY',
    'G-POWER',
    'GB POWER',
    'GEXA ENERGY',
    'GREEN DIRECT',
    'GREEN ENERGY EXCHANGE',
    'GREEN MOUNTAIN ENERGY ',
    'GRIDDY ENERGY',
    'GRIDPLUS ENERGY',
    'HELLO ENERGY',
    'HERITAGE POWER',
    'HUDSON ENERGY SERVICES',
    'HYBRID POWER',
    'IBERDROLA',
    'IGS ENERGY',
    'ILUMINAR ENERGY',
    'INFINITE ENERGY',
    'INFUSE ENERGY',
    'JP ENERGY',
    'JUST ENERGY',
    'LIBERTY POWER',
    'LONE STAR ENERGY',
    'MIDAMERICAN ENERGY SERVICES',
    'MILESTONE ENERGY',
    'MIO ELECTRIC',
    'MP2 ENERGY',
    'MY QUEST ENERGY',
    'NATIONAL GAS & ELECTRIC',
    'NEC RETAIL',
    'NEO ELECTRICITY',
    'NEW LEAF ENERGY',
    'NEW POWER TEXAS',
    'NEWENERGY',
    'NORTH AMERICAN POWER AND GAS',
    'NOVA ELECTRIC CO',
    'NOW POWER',
    'OHM CONNECT',
    'OLIN CORPORATION',
    'OTHER',
    'OUR ENERGY',
    'PAGA MENOS',
    'PAYLESS POWER',
    'PENNYWISE POWER',
    'PENSTAR POWER',
    'PESO POWER',
    'PILOT POWER GROUP',
    'POGO ENERGY',
    'POWER HOUSE ENERGY',
    'POWER OF TEXAS',
    'POWERNEXT',
    'POWERPASS',
    'PREMIUM POWER & LIGHT',
    'PREPAY POWER',
    'PRO POWER PROVIDERS',
    'PRONTO POWER',
    'PULSE POWER',
    'RELIANT ENERGY',
    'RHYTHM',
    'RODEO ENERGY',
    'SFE ENERGY',
    'SG&E',
    'SHELL ENERGY',
    'SMART PREPAID ELECTRIC',
    'SMARTENERGY',
    'SOL ENERGY',
    'SOUTHERN FEDERAL POWER',
    'SOUTHWEST POWER & LIGHT',
    'SPARK ENERGY',
    'STARTEX POWER',
    'STAT ENERGY',
    'STREAM ENERGY',
    'SUMMER ENERGY',
    'SUPER POWER',
    'TALEN ENERGY',
    'TARA ENERGY',
    'TERM ENERGY',
    'TEXANS ENERGY',
    'TEXAS POWER OUTLET',
    'TEXPO ENERGY',
    'THINK ENERGY',
    'TITAN GAS AND POWER',
    'TOMORROW ENERGY CORP',
    'TOTAL GAS & POWER',
    'TOWN SQUARE ENERGY',
    'TRAILSTONE ENERGY MARKETING',
    'TRIEAGLE ENERGY SERVICES',
    'TXU ENERGY',
    'UNO ENERGY',
    'US ENERGY SAVINGS CORP',
    'US RETAILERS',
    'V247 POWER',
    'VALUE BASED BRANDS',
    'VARSITY ENERGY',
    'VETERAN ENERGY',
    'VIRIDIAN ENERGY',
    'VITAL POWER',
    'VOLT ELECTRICITY',
    'WINDROSE ENERGY',
    'WORLD POWER & GAS',
    'WTU',
    'XOOM ENERGY',
    'YEP',
    'YOUNG ENERGY',
    'ZIP ENERGY',
  ],
};

export const currentProviderList = {
  texas_ep: [
    'Accounting',
    'Adult Store',
    'Adult Education',
    'Aircraft Facility',
    'Agriculture',
    'Ambulatory Surgical Center',
    'Amusement Park',
    'Animal Hospital',
    'Apartment Complex',
    'Apparel',
    'Arcade',
    'Arts',
    'Assisted Living',
    'Athletic Field',
    'Auditorium',
    'Auto Glass Repair Shop',
    'Automotive Repair Shop',
    'Automotive Sales Dealership',
    'Automotive Wrecking',
    'Bank Branch',
    'Banking',
    'Bar',
    'Beauty Salon',
    'Billiard Hall',
    'Biotechnology',
    'Bowling Alley',
    'Bottling Plant',
    'Bulk Plant',
    'Business Park',
    'Canning Plant',
    'Carpet',
    'Car Wash',
    'Casino',
    'Cemetery',
    'Charitable Organization',
    'Chemicals',
    'Clinic',
    'Clothes',
    'Club',
    'College',
    'Commercial',
    'Communications',
    'Communication Facility',
    'Computers',
    'Condominium Complex',
    'Construction',
    'Consulting',
    'Convalescent Hospital',
    'Convenience Store',
    'Convention Center',
    'Cooperative',
    'Correctional Facility',
    'Country Club',
    'Courthouse',
    'Crematorium',
    'Daycare',
    'Dance Hall',
    'Data Center',
    'Dental Office',
    'Department Store',
    'Distribution Center',
    'Dormitories',
    'Drinking Water Treatment & Distribution',
    'Drug Store',
    'Drycleaning ',
    'Dump Site',
    'Duplex',
    'Education',
    'Electrical Contractor',
    'Electronics',
    'Energy',
    'Engineering',
    'Environmental',
    'Facilities',
    'Fast Food Restaurant',
    'Finance',
    'Financial Building',
    'Financial Services',
    'Fire Station',
    'Fitness Club',
    'Food & Beverage',
    'Food Packing',
    'Fraternity House',
    'Funeral Home',
    'Garage',
    'Gas Station',
    'Gas Production',
    'General Industrial',
    'General Services',
    'General Warehousing',
    'Golf Course & Country Club',
    'Golf Range',
    'Government Building',
    'Grocery Store',
    'Group Quarters',
    'Gym',
    'Harbor',
    'Healthcare',
    'Health spa',
    'Heavy Industrial',
    'Horse Race Track',
    'Hospital',
    'Hospitality',
    'Hotel',
    'Hotel Condominium',
    'Industrial Park',
    'Industrial Plant',
    'Insurance',
    'K-12 School',
    'Kennel',
    'Laboratory',
    'Laundromat',
    'Law Firm',
    'Legal Services',
    'Library',
    'Light Industrial',
    'Lodges',
    'Lumber Mill',
    'Lumber Yard',
    'Machinery',
    'Mailing Center',
    'Manufacturing Plant',
    'Marine Facility',
    'Marine',
    'Media',
    'Medical Building',
    'Medical Condominium',
    'Memory Care Facility',
    'Metal Production',
    'Mine',
    'Mineral Processing',
    'Mobile Home Park',
    'Motel',
    'Movie Theater',
    'Museum',
    'Native American Property',
    'Nature Facility',
    'Nightclub',
    'Non-Profit',
    'Nursing Home',
    'Office Building',
    'Office Condominium',
    'Oil Facility',
    'Orphanage',
    'Orthodontics',
    'Other Repair Services',
    'Other',
    'Outpatient Rehab',
    'PUD Common Space',
    'Paper & Allied Industry',
    'Parking Lot',
    'Parking Structure',
    'Performing Arts',
    'Petroleum',
    'Pharmacy',
    'Physical Therapy',
    'Port',
    'Post Office',
    'Pre-School',
    'Prison',
    'Professional Associations',
    'Property Management',
    'Public Storage',
    'Quadplex',
    'Quarry',
    'R&D Facility',
    'Race Track',
    'Racquet Court',
    'Railroad Facility',
    'Ranch',
    'Real Estate',
    'Recording Studio',
    'Recreation Center',
    'Refinery',
    'Religious Place of Worship',
    'Residential Care Facility',
    'Resort',
    'Restaurant',
    'Retail Store',
    'Retirement Community',
    'RV Park',
    'Salon',
    'Senior Care Facility',
    'Service Station',
    'Shipyard',
    'Shipping',
    'Shopping Mall',
    'Skating Park',
    'Social Meeting Hall',
    'Sorority House',
    'Spa',
    'Stadium',
    'Storage (Temp Controlled)',
    'Storage Tanks',
    'Supermarket',
    'Supercenter',
    'Surgery Center',
    'Swimming Pool',
    'Tavern',
    'Travel Agency',
    'Technology',
    'Telecommunications',
    'Tennis Club',
    'Terminal Station',
    'Textile',
    'Theater',
    'Tourist Attraction',
    'Transient Lodging',
    'Transportation',
    'Travel',
    'Triplex',
    'TV Facility',
    'Urgent Care',
    'University',
    'Utilities',
    'Veterinary Clinic',
    'Veterinary Hospital',
    'Vocational School',
    'Warehouse',
    'Waste Disposal',
    'Wastewater Treatment Plant',
    'Well',
    'Wholesale Club',
  ],
};
